import { Component, inject, input, signal } from '@angular/core';
import { LossPreventionService } from '../../../../service/loss-prevention.service';
import { NotifyService } from '../../../../service/notify.service';
import { tryGetErrorMessage } from '../../../../error.utils';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-video-password-actions',
  templateUrl: './video-password-actions.component.html',
  standalone: false,
})
export class VideoPasswordActionsComponent {
  private lpService = inject(LossPreventionService);
  private notifyService = inject(NotifyService);
  public reviewId = input.required<string>();
  public passwordAction = input<'clear' | 'refresh'>('clear');
  public isPending = signal<boolean>(false);

  refreshVideoPassword() {
    this.isPending.set(true);
    this.lpService
      .refreshVideoPassword(this.reviewId())
      .pipe(finalize(() => this.isPending.set(false)))
      .subscribe(
        (data) => this.notifyService.notify(`Successfully refreshed ${data.affected_video_links} passwords`),
        (err) => this.notifyService.notify(tryGetErrorMessage(err)),
      );
  }

  clearVideoPassword() {
    this.isPending.set(true);
    this.lpService
      .clearVideoPassword(this.reviewId())
      .pipe(finalize(() => this.isPending.set(false)))
      .subscribe(
        (data) => this.notifyService.notify(`Successfully cleared ${data.affected_video_links} passwords`),
        (error) => this.notifyService.notify(tryGetErrorMessage(error)),
      );
  }
}
